export default __webpack_public_path__ + "static/SUPPORTS FOR LANGUAGE LEARNING 3_v2-2d8253a18eb55076cb776387531d719b.png";